class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this._isFirstLoad = true;

    // ✅ DO NOT force show/hide buttons here — let updateButtonState handle it
    // based on actual variant data. Forcing visibility here causes the flash
    // of wrong state on first load.

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        requestAnimationFrame(() => this.onVariantChange());
      });
    } else {
      requestAnimationFrame(() => this.onVariantChange());
    }
  }

  // ✅ Helper: finds the notify button using the correct selector from your Liquid.
  // Your Liquid renders notify as <div class="btn btnsold_out sold_out">, NOT name="add2"
  getNotifyBtn(form) {
    return (
      form?.querySelector('.btnsold_out') ??
      form?.querySelector('[name="add2"]') ??
      document.querySelector('.btnsold_out') ??
      document.querySelector('[name="add2"]')
    );
  }

  // ✅ Helper: finds the add to cart button
  getAddBtn(form) {
    return (
      form?.querySelector('[name="add"]') ??
      document.querySelector('[name="add"]')
    );
  }

  // ✅ NEW: Helper: finds the custom order button
  getCustomOrderBtn(form) {
    return (
      form?.querySelector('.btn-custom-order') ??
      document.querySelector('.btn-custom-order')
    );
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.setUnavailable();
      return;
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();

    const variant = this.currentVariant;

    if (this._isFirstLoad) {
      this._isFirstLoad = false;
      this.updateButtonState(variant);
    } else {
      this.renderProductInfo().then(() => {
        this.currentVariant = variant;
        this.updateButtonState(variant);
      });
    }

    // Swatch update
    const colorValue = this.currentVariant.options[0];
    const swatchContainer = document.querySelector('.product-swatch-color');
    if (swatchContainer) {
      swatchContainer.querySelectorAll('.swatch-element').forEach((swatch) => {
        swatch.classList.toggle(
          'active',
          swatch.getAttribute('data-value') === colorValue
        );
      });
    }
  }

  updateButtonState(variant = this.currentVariant) {
    if (!variant) {
      this.setUnavailable();
      return;
    }

    const optionEl = document
      .getElementById('productSelect')
      ?.querySelector(`[value="${variant.id}"]`);

    const qty = parseInt(optionEl?.getAttribute('data-qty') ?? '0', 10);
    const isDisabled = optionEl?.hasAttribute('disabled') ?? false;
    const isOutOfStock = isDisabled || qty < 1;

    const form = document.getElementById(`product-form-${this.dataset.section}`);

    // Ensure the wrapper is never force-hidden
    const addWrapper = form?.querySelector('.product-form__item--submit');
    if (addWrapper) {
      addWrapper.classList.remove('hidden-force');
      addWrapper.style.removeProperty('display');
    }

    // ✅ Use corrected selectors
    const addBtn = this.getAddBtn(form);
    const notifyBtn = this.getNotifyBtn(form);
    const customBtn = this.getCustomOrderBtn(form);
    const availabilityEl = document.querySelector('.product__available');

    // ✅ Check if product has 'customize' tag
    const isCustomize = window.__productTags && window.__productTags.indexOf('customize') !== -1;

    console.log('Variant:', variant.id, '| qty:', qty, '| disabled:', isDisabled, '| OOS:', isOutOfStock);
    console.log('addBtn found:', addBtn);
    console.log('notifyBtn found:', notifyBtn);
    console.log('customBtn found:', customBtn);
    console.log('isCustomize:', isCustomize);

    // ✅ Custom Order button logic
    if (isCustomize && customBtn) {
      if (isOutOfStock) {
        // Out of stock: Show Notify Me, Hide Custom Order
        customBtn.style.setProperty('display', 'none', 'important');
        if (addBtn) {
          addBtn.style.setProperty('display', 'none', 'important');
          addBtn.setAttribute('disabled', 'true');
        }
        if (notifyBtn) {
          notifyBtn.style.setProperty('display', 'flex', 'important');
        }
      } else {
        // In stock: Show Custom Order, Hide Add to Cart & Notify Me
        customBtn.style.setProperty('display', 'block', 'important');
        if (addBtn) {
          addBtn.style.setProperty('display', 'none', 'important');
          addBtn.setAttribute('disabled', 'true');
        }
        if (notifyBtn) {
          notifyBtn.style.setProperty('display', 'none', 'important');
        }
      }
      
      // Update availability text for customize products
      if (availabilityEl) {
        if (isOutOfStock) {
          availabilityEl.className = 'product__available out-of-stock';
          availabilityEl.innerHTML = '<span>Out of stock</span><i class="fa fa-times-circle-o" aria-hidden="true"></i>';
        } else {
          availabilityEl.className = 'product__available in-stock';
          availabilityEl.innerHTML = '<span>In stock</span><i class="fa fa-check-square-o" aria-hidden="true"></i>';
        }
      }
      
      return; // ✅ Exit early for customize products
    }

    // ✅ Original logic for non-customize products
    if (isOutOfStock) {
      if (addBtn) {
        addBtn.style.setProperty('display', 'none', 'important');
        addBtn.setAttribute('disabled', 'true');
      }
      if (notifyBtn) {
        notifyBtn.style.setProperty('display', 'flex', 'important');
      }
      if (availabilityEl) {
        availabilityEl.className = 'product__available out-of-stock';
        availabilityEl.innerHTML = '<span>Out of stock</span><i class="fa fa-times-circle-o" aria-hidden="true"></i>';
      }
    } else {
      if (addBtn) {
        addBtn.style.setProperty('display', 'block', 'important');
        addBtn.removeAttribute('disabled');
      }
      if (notifyBtn) {
        notifyBtn.style.setProperty('display', 'none', 'important');
      }
      if (availabilityEl) {
        availabilityEl.className = 'product__available in-stock';
        availabilityEl.innerHTML = '<span>In stock</span><i class="fa fa-check-square-o" aria-hidden="true"></i>';
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;

    document.querySelectorAll('.FeaturedImage_slick .item')
      .forEach((el) => el.classList.remove('act'));
    newMedia.classList.add('act');

    if (window.jQuery?.fn?.slick) {
      const $ = window.jQuery;
      const $slick = $('.FeaturedImage_slick');
      const $slide = $slick
        .find(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`)
        .closest('.slick-slide');
      if ($slide.length) {
        $slick.slick('slickGoTo', $slide.data('slick-index'));
      }
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    document
      .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`)
      .forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    return fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const id = `ProductPrice-${this.dataset.section}`;
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');

        const variant_id = document.getElementById('variant_id')?.value;
        const option = document.getElementById('productSelect')?.querySelector(`[value="${variant_id}"]`);
        const sku = option?.getAttribute('data-sku');
        const variantSku = document.getElementById('variantSku');
        if (variantSku && sku) variantSku.innerHTML = sku;
      });
  }

  toggleAddButton(disable = true, text) {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    if (!form) return;

    const addWrapper = form.querySelector('.product-form__item--submit');
    const addButton = this.getAddBtn(form);
    const notifyBtn = this.getNotifyBtn(form);
    const customBtn = this.getCustomOrderBtn(form);
    const isCustomize = window.__productTags && window.__productTags.indexOf('customize') !== -1;

    // ✅ Handle customize products
    if (isCustomize && customBtn) {
      if (disable) {
        customBtn.style.setProperty('display', 'none', 'important');
        if (notifyBtn) {
          notifyBtn.style.setProperty('display', 'flex', 'important');
          const txt = notifyBtn.querySelector('#txt-notify');
          if (text && txt) txt.textContent = text;
        }
      } else {
        customBtn.style.setProperty('display', 'block', 'important');
        if (notifyBtn) notifyBtn.style.setProperty('display', 'none', 'important');
      }
      if (addButton) {
        addButton.style.setProperty('display', 'none', 'important');
        addButton.setAttribute('disabled', 'true');
      }
      return;
    }

    // ✅ Original logic for non-customize products
    if (disable) {
      if (addButton) {
        addButton.setAttribute('disabled', 'true');
        addButton.style.setProperty('display', 'none', 'important');
      }
      if (notifyBtn) {
        notifyBtn.style.setProperty('display', 'flex', 'important');
        const txt = notifyBtn.querySelector('#txt-notify');
        if (text && txt) txt.textContent = text;
      }
    } else {
      if (addWrapper) addWrapper.classList.remove('hidden-force');
      if (addButton) {
        addButton.removeAttribute('disabled');
        addButton.style.setProperty('display', 'inline-block', 'important');
      }
      if (notifyBtn) notifyBtn.style.setProperty('display', 'none', 'important');
      const txtBtn = addButton?.querySelector('#AddToCartText');
      if (txtBtn) {
        txtBtn.textContent = this.currentVariant.available
          ? window.variantStrings.addToCart
          : window.variantStrings.soldOut;
      }
    }
  }

  setUnavailable() {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    if (!form) return;
    const addButton = this.getAddBtn(form);
    const notifyBtn = this.getNotifyBtn(form);
    const customBtn = this.getCustomOrderBtn(form);
    const isCustomize = window.__productTags && window.__productTags.indexOf('customize') !== -1;

    if (isCustomize && customBtn) {
      customBtn.style.setProperty('display', 'none', 'important');
      if (notifyBtn) notifyBtn.style.setProperty('display', 'flex', 'important');
    } else {
      if (addButton) {
        addButton.style.setProperty('display', 'none', 'important');
        addButton.setAttribute('disabled', 'true');
      }
      if (notifyBtn) notifyBtn.style.setProperty('display', 'flex', 'important');
    }
    document.getElementById(`ProductPrice-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return fieldset.querySelector('input:checked')?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);